export default "import '@testing-library/jest-dom';"